import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthData } from '@se/models';
import { Observable } from 'rxjs';
import { ServerRootService } from '../../../utils/routing/serverroot.service';
import { IDataSourceItem } from '@se/cp.common';

/** Il servizio deve contenere tutte le chiamate ai metodi rest nel controller ReportCore!
 * Ogni metodo non deve avere logica ma solo effettuare la chiamata.
 * il tipo di ritorno deve essere sempre un Observable
 */
export abstract class ListBaseService extends ServerRootService {
    protected readonly httpClient = inject(HttpClient);

    getList(lsName: string, authData?: AuthData): Observable<IDataSourceItem[]> {
        return this.httpClient.get<IDataSourceItem[]>(
            this.getServerRoot() + `/List/GetList?lsName=${lsName}`,
            this.buildOptions(authData),
        );
    }
}
